import{readTextFile as r}from"./readTextFile.js";const t=async t=>{if(!t)return"";try{return await r(String(t))}catch(r){return console.error(r),""}};export{t as handleGetFileText};
//# sourceMappingURL=handleGetFileText.js.map
